import axios from 'axios';

export class ErrorResponse {
  static getMessage(error: unknown): string {
    if (axios.isAxiosError(error)) {
      return error.message;
    } else if (error instanceof Error) {
      return error.message;
    } else if (typeof error === 'string') {
      return error;
    } else {
      return 'An unexpected error occurred';
    }
  }
}
